import {Component, DestroyRef, Inject, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {GetAllAdgroupPayloadModel} from './adgroup_interfaces';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {Router} from '@angular/router';
import {
  CurrentAdgroupSelectService,
  CurrentCrudSelectBehaviorServiceAsString,
  CurrentSelectedSlugBehaviorService,
  SnackBarService
} from '../objectPassingService';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AdgroupService} from './adgroups_service';
import {MatCard, MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormField, MatInput, MatInputModule, MatLabel} from '@angular/material/input';
import {MatButtonModule, MatFabButton, MatIconButton} from '@angular/material/button';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatProgressBar, MatProgressBarModule} from '@angular/material/progress-bar';
import { NgClass } from '@angular/common';
import {MatDivider, MatDividerModule} from '@angular/material/divider';
import {MatList, MatListItem, MatListModule} from '@angular/material/list';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';

export interface CreateAdgroupInitPayload {
  is_edit: false;
}


@Component({
  selector: 'app-adgroups',
  imports: [
    MatProgressBar,
    MatList,
    MatListItem,
    MatDivider,
    MatIcon,
    MatTooltip,
    MatFabButton,
    MatLabel,
    MatFormField,
    MatInput,
    MatTable,
    MatCard,
    MatHeaderCell,
    MatCell,
    MatSort,
    MatColumnDef,
    MatIconButton,
    MatPaginator,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatSortHeader,
    NgClass
],
  templateUrl: './adgroups.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './adgroups.component.css'
})
export class AdgroupsComponent implements OnInit, OnDestroy {



  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();
  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  campaign_group_id: string = '';
  campaign_id: string = '';
  is_loading = true;

  dataSource!: MatTableDataSource<GetAllAdgroupPayloadModel>;
  displayedColumns: string[] = ['adgroup_id', 'name', 'type', 'status', 'View', 'Edit', 'Delete'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public router: Router, //all components need this
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    private currentCrudSelectBehaviorServiceAsString: CurrentCrudSelectBehaviorServiceAsString,
    public dialog: MatDialog,
    private adgroupService: AdgroupService,
    private currentAdgroupSelectService: CurrentAdgroupSelectService
  ) { } //end constructor

  ngOnInit(): void {

    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');

    this.client_id = parseInt(localStorage.getItem('client_id') || '0');
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_id = localStorage.getItem('campaign_group_id') || '';
    this.campaign_id = localStorage.getItem('campaign_id') || '';

    if (this.campaign_id) {
      this.getData(false)
    } else {
      this.is_loading = false;
    }
  } //end ngOnInit

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } //end ngOnDestroy

  getData(is_mocked:boolean = false) {

    this.is_loading = true;
    const show_deleted = 'false'

    this.adgroupService.gets(`adserver/adgroups/${this.campaign_id}`, is_mocked).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.is_loading = false;
      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe
  } //end getData

  addAdgroup(is_edit: boolean, row?: GetAllAdgroupPayloadModel): void {

    localStorage.removeItem('adgroupsaved');
    localStorage.removeItem('adsaved');
    if (is_edit && row) {
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(row));
    } else {
      const payload: CreateAdgroupInitPayload = { is_edit: false };
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(payload));
    }
    // Ensure subscribers are ready before navigation
    // It’s faster and cleaner than setTimeout(..., 0).
    queueMicrotask(() => {
      this.router.navigate(
        ['/nav-campaigns', { outlets: { admeta: ['adgroups-meta'] } }]
      ).then(() => console.log('Redirected to ads-meta'));
    });
  }

  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  deleteRow(row: GetAllAdgroupPayloadModel){

    let adgroup_id = row.adgroup_id;
    this.adgroupService.delete(`adserver/adgroup/${adgroup_id}`).pipe(takeUntil(this.destroyed)).subscribe(x => {
      console.log(x);
      this.getData(false);
    }, error => {
      console.log('error',error)
    });

    console.log('deleteRow', row);
  } //end deleteRow

  viewData(row: GetAllAdgroupPayloadModel) {
    console.log('viewData', row);
    const adgroup_id = row.adgroup_id
    //this.currentCampaignGroupSelectService.announceCampaignGroupSelect(campaign_group_id);
    localStorage.setItem('adgroup_id', adgroup_id);
    localStorage.removeItem('ad_id');

    let adgroup_type = row.type;
    localStorage.setItem('adgroup_type', adgroup_type);

    localStorage.setItem('adgroup_name', row.name);
    this.currentAdgroupSelectService.announceAdgroupSelect(row.name);


    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['ads'] } }],{
      queryParams: {
        adgroup_id: adgroup_id,
      }
    }).then(r => console.log('redirect to ads'));
  } //end viewData(row)

} //end AdgroupsComponent

